module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "verify-email-form"
    }
  }, [_c('p', {
    staticClass: "enter-code-notice"
  }, [_vm._v(_vm._s(_vm.$t('enterCodeNotice')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "verificationCode"
    }
  }, [_vm._v(_vm._s(_vm.$t('placeholder.yourCode')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits: 5'),
      expression: "'required|numeric|digits: 5'"
    }],
    class: {
      'danger-border': _vm.showError && _vm.codeError
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "verificationCode",
      "placeholder": _vm.$t('placeholder.yourCode'),
      "name": "verificationCode"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.bindingEmail($event)
      },
      "blur": function($event) {
        _vm.showError = true
      },
      "focus": function($event) {
        _vm.showError = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError && _vm.errors.has('verificationCode')),
      expression: "showError && errors.has('verificationCode')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('verificationCode')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError),
      expression: "showError"
    }]
  }, [_vm._v(_vm._s(_vm.errorMsg))])]), _vm._v(" "), _c('p', {
    staticClass: "not-received"
  }, [(_vm.countDown > 0) ? [_c('span', [_vm._v(_vm._s(_vm.$t('sent')) + _vm._s(_vm.countDown) + _vm._s(_vm.$t('seconds')))])] : [_c('span', {
    staticClass: "resend",
    on: {
      "click": _vm.sendVerificationCodeToEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('resend')))])]], 2)]), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "form-submit",
    on: {
      "click": _vm.bindingEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-487553d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/verifyEmailForm/VerifyEmailForm.vue
// module id = 1317
// module chunks = 1